// Recurpay custom code Begins
 function handleRadioChange() {
    const selectedRadio = document.querySelector('.product__info-wrapper kaching-bundle .kaching-bundles__bars input[type="radio"]:checked');
    const variantName = selectedRadio ? selectedRadio.closest('.kaching-bundles__bar').querySelector('.kaching-bundles__bar-title').textContent : null;
    var bundle_price = selectedRadio ? selectedRadio.closest('.kaching-bundles__bar').querySelector('.kaching-bundles__bar-pricing .kaching-bundles__bar-price').innerHTML : null;
    var newPrice = bundle_price;
    if (newPrice) {
      let { value: numericValue, currencySymbol, symbolPosition } = parsePriceString(newPrice);
      let discountElement = document.querySelector('.recurpay__frequency_select')?.selectedOptions[0];
      let discount = discountElement ? parseFloat(discountElement.getAttribute('data-plan-discount')) || 0 : 0;
  
      let discountedValue = numericValue - (numericValue * (discount / 100));
  
      let finalPrice = formatPriceWithOriginalSymbol(discountedValue, currencySymbol, symbolPosition);
       
      const selectElement = document.querySelector('.recurpay__frequency_select');
      // setTimeout(function (){
        document.querySelector(".recurpay__widget_container[data-type='onetime-purchase'] .recurpay__group_label .recurpay__group_selling_price .money").innerHTML = bundle_price;
        document.querySelector(".recurpay__widget_container[data-type='subscription-purchase'] .recurpay__group_label .recurpay__group_compare_price .money").innerHTML = bundle_price;
        document.querySelector(".recurpay__widget_container[data-type='subscription-purchase'] .recurpay__group_label .recurpay__group_selling_price .money").innerHTML = finalPrice;
     // }, 1500);
  }
 }

  function parsePriceString(priceStr) {
    let currencyMatch = priceStr.match(/^[^\d\s]+|[^\d\s]+$/g);
    let currencySymbol = currencyMatch ? currencyMatch[0] : '$';

    let position = priceStr.trim().startsWith(currencySymbol) ? 'before' : 'after';

    // Normalize price string (handle comma/dot formats)
    let numericStr = priceStr.replace(/[^\d,.-]/g, '').trim();

    // Detect format: if there are both comma and dot
    if (numericStr.includes(',') && numericStr.includes('.')) {
        if (numericStr.lastIndexOf(',') > numericStr.lastIndexOf('.')) {
            numericStr = numericStr.replace(/\./g, '').replace(',', '.'); 
        } 
        else {
            numericStr = numericStr.replace(/,/g, ''); 
        }
    } 
    else if (numericStr.includes(',')){
        const commaCount = (numericStr.match(/,/g) || []).length;
        if (commaCount === 1 && numericStr.split(',')[1].length <= 2) {
            numericStr = numericStr.replace(',', '.'); 
        } else {
            numericStr = numericStr.replace(/,/g, '');
        }
    }

    return {
        value: parseFloat(numericStr),
        currencySymbol,
        symbolPosition: position
    };
}

  function formatPriceWithOriginalSymbol(value, currencySymbol, symbolPosition) {
    let formatMap = {
        '$': 'en-US',
        '€': 'de-DE',
        '₹': 'en-IN',
        '£': 'en-GB',
        '¥': 'ja-JP'
    };

    let currencyMap = {
        '$': 'USD',
        '$': 'SDG',
        '€': 'EUR',
        '₹': 'INR',
        '£': 'GBP',
        '¥': 'JPY'
    };

    let locale = formatMap[currencySymbol] || 'en-US';
    let currencyCode = currencyMap[currencySymbol] || 'USD';
    
    debugger;
    let roundedValue = Math.floor(value * 100) / 100;

    // Format the number using locale
    let formatted = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
        currencyDisplay: 'symbol',
        minimumFractionDigits: 2
    }).format(roundedValue);

    // Force the symbol position based on original format
    let rawNumber = roundedValue.toLocaleString(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    return symbolPosition === 'before'
        ? `${currencySymbol}${rawNumber}`
        : `${rawNumber} ${currencySymbol}`;
}

  function updateQuantity(){
    let selectedRadio = document.querySelector('.product__info-wrapper kaching-bundle .kaching-bundles__bars input[type="radio"]:checked');
    let variantName = selectedRadio ? selectedRadio.closest('.kaching-bundles__bar').querySelector('.kaching-bundles__bar-title').textContent : null;
    if(variantName == 'Buy 1 Get 1 Free'){
      document.querySelector('.product__info-container input[name="quantity"]').value = 2;
    }
    else if(variantName == 'Buy 2 Get 2 Free'){
      document.querySelector('.product__info-container input[name="quantity"]').value = 4;
    }
    else if(variantName == 'Buy 3 Get 3 Free'){
      document.querySelector('.product__info-container input[name="quantity"]').value = 6;
    }
    else if(variantName == 'Buy 4 Get 4 Free'){
      document.querySelector('.product__info-container input[name="quantity"]').value = 8;
    }
     handleRadioChange();
  }

  function handleMutations(mutationsList) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        if (document.getElementsByClassName('recurpay__widget').length > 0 && document.getElementsByClassName('kaching-bundles__bars').length > 0) {
         const container = document.querySelector('.product__info-wrapper');
          if(container){
            container.addEventListener('change', (event) => {
              if (event.target.matches('.kaching-bundles__bar input[type="radio"]')) {
                handleRadioChange();
              }
           });
          }
          setTimeout(function(){
             handleRadioChange()
          }, 1500);
           document.querySelectorAll("[data-recurpay-action], .product-form__submit").forEach(function(element) {
              element.addEventListener("click", function() {
                setTimeout(function(){
                  updateQuantity();
                }, 3000)
              });
          })
        document.body.addEventListener('click', function(event) {
          if(event.target.closest('.cart-drawer-item__cart-remove-button')) {
                let button = event.target.closest('.cart-drawer-item__cart-remove-button').querySelector('button');
                if (button) {
                    setTimeout(function(){
                      updateQuantity();
                    }, 3000);
                }
            }
        });
          observer.disconnect();
          break;
        }
      }
    }
  }
  const observer = new MutationObserver(handleMutations);
  observer.observe(document.body, { childList: true, subtree: true });
// Recurpay custom code ends